import type { EmployeeAlertInvalidJapanesePhoneticName } from '@/common/graphql';

export const DetailDescriptionEmployeeAlertInvalidJapanesePhoneticName = ({
  reason,
}: {
  reason: Pick<EmployeeAlertInvalidJapanesePhoneticName, 'japanesePhoneticName' | 'detailMessage'>;
}) => (
  <>
    <div>
      ﾌﾘｶﾞﾅ (Kana of Japanese):&nbsp;
      {reason.japanesePhoneticName}
    </div>
    <div>
      Reason:&nbsp;
      {reason.detailMessage}
    </div>
  </>
);
